// extracted by mini-css-extract-plugin
export var markdown = "_um-0";
export var tableWrapper = "_um-1";